import script from "./BaseCol.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCol.vue?vue&type=script&setup=true&lang=js"

import "./BaseCol.vue?vue&type=style&index=0&id=2803556c&lang=scss&scoped=true"

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2803556c"]])

export default __exports__